var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.title)?_c('div',{staticClass:"page-block-title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),_c('div',{staticClass:"page-block",class:_vm.classes},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }